import { render, staticRenderFns } from "./MenteeMessages.vue?vue&type=template&id=ce72a21a&"
import script from "./MenteeMessages.vue?vue&type=script&lang=js&"
export * from "./MenteeMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports